// extracted by mini-css-extract-plugin
export default {"header":"ExerciseHeader_header__2kuuf"};